const onVote = function() {
  this.classList.add("upvote-upvoting")
}
// Extend upvote object to modify event
const upvote = window.upvote

upvote.isUpvoting = false

upvote.upvote = function(elementId, key) {
  if (this.isUpvoting) return
  this.isUpvoting = true
  // TODO Reinitialize this.isUpvoting if voting ajax request return an error

  if (this.devMode) {
    console.log(
      "[" + elementId + "]" + (key ? " [" + key + "]" : "") + " Upvoting..."
    )
  }
  this._vote(elementId, key, "upvote")
}

upvote._addMatchClass = function(icons) {
  this.updateTotalNumber = 1
  this._removeLoadingClass(icons)
  for (var i = 0; i < icons.length; i++) {
    icons[i].classList.add("upvote-vote-match")
  }
}

upvote._removeMatchClass = function(icons) {
  this.updateTotalNumber = -1
  this._removeLoadingClass(icons)
  for (var i = 0; i < icons.length; i++) {
    icons[i].classList.remove("upvote-vote-match")
  }
}

upvote._addLoadingClass = function(icons) {
  for (var i = 0; i < icons.length; i++) {
    icons[i].classList.add("upvote-upvoting")
  }
}

upvote._removeLoadingClass = function(icons) {
  this.isUpvoting = false
  this.updateTotalIndicator(icons, 66)
  for (var i = 0; i < icons.length; i++) {
    icons[i].classList.remove("upvote-upvoting")
  }
}

upvote.updateTotalIndicator = function(icons, number) {
  for (var i = 0; i < icons.length; i++) {
    const dataSet = icons[i].parentElement.dataset.totalupvotes
    let total = Number(dataSet) + this.updateTotalNumber
    icons[i].parentElement.dataset.totalupvotes = total
  }
}

const Applause = el => {
  el.querySelector(".upvote-vote").addEventListener("click", onVote)
}

export { Applause }
